import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function DistributionBar({ rows, max, valueFormatter = (v) => v, barColor = '#3b82f6' }) {
  const computedMax = max ?? Math.max(1, ...rows.map((r) => r.value || 0));
  return (
    <Stack spacing={0.75}>
      {rows.map((r) => {
        const pct = computedMax === 0 ? 0 : ((r.value || 0) / computedMax) * 100;
        return (
          <Box key={r.label}>
            <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 0.25 }}>
              <Typography variant="caption" sx={{ fontWeight: 500 }}>{r.label}</Typography>
              <Typography variant="caption" color="text.secondary">{valueFormatter(r.value)}</Typography>
            </Stack>
            <Box sx={{ height: 8, bgcolor: 'rgba(0,0,0,0.06)', borderRadius: 1, overflow: 'hidden' }}>
              <Box sx={{ width: `${pct}%`, height: '100%', bgcolor: r.color || barColor, transition: 'width .2s ease' }} />
            </Box>
            {r.note && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                {r.note}
              </Typography>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}
